import DisabledFormSection from 'components/DisabledFormSection';
import FormRow from 'components/FormRow';
import FormSection from 'components/FormSection';
import { InputWithField } from 'components/Input';
import { YesNoRadioGroupWithField } from 'components/YesNoRadioGroup';
import { usePartnerConfig } from 'config/partner/hooks';
import { useShowNameOfContactPerson } from 'mittweida/config/conditions';
import { mittweidaFields, MittweidaSections } from 'mittweida/inquiry/fields';
import { translations } from 'new/form/common/types';
import { Condition } from 'new/form/Condition';
import { FoundingMonthSelect } from 'ui/companyDetails/foundingMonth/select';
import { ProfileIndustrySelect } from 'ui/companyDetails/industry/select';
import { TurnoverClassSelect } from 'ui/companyDetails/turnoverClass/select';
import { useTranslations } from 'utils/hooks/useTranslations';

import { CompanyInformationForm } from './components/CompanyInformationForm';
import { LegalForm } from './components/LegalForm';

const {
  industry,
  turnoverClass,
  foundingYear,
  foundingMonth,
  alreadyCustomer,
  alreadyContactWithBank,
  nameOfContactPerson,
} = mittweidaFields.companyDetailPage.completingCompanyDetailsSection.company;

export const CompletingCompanyDetailsSection = () => {
  const t = useTranslations();
  const { title, fallback } =
    translations.inquiryType.mittweida.pages.companyDetails.sections.completingCompanyDetails;
  const { userProfileAlreadyContactWithBank, userProfileContactPerson } =
    translations.pages.userProfile.sections.completingCompanyDetails.fields;

  const {
    details: { fullName: partnerName },
  } = usePartnerConfig();

  const showContactPersonName = useShowNameOfContactPerson();

  return (
    <Condition<MittweidaSections>
      validation={'companyDetailsSection'}
      fallback={
        <DisabledFormSection sectionNumber={2} placeholder={t(fallback)} title={t(title)} />
      }
    >
      <FormSection title={t(title)} sectionNumber={2} name={'completingCompanyDetails'}>
        <CompanyInformationForm />
        <FormRow>
          <LegalForm />
        </FormRow>

        <FormRow>
          <ProfileIndustrySelect name={industry} />
        </FormRow>

        <FormRow>
          <TurnoverClassSelect name={turnoverClass} />
        </FormRow>

        <FormRow>
          <InputWithField name={foundingYear} type={'number'} separateThousands={false} />
          <FoundingMonthSelect name={foundingMonth} optional={true} />
        </FormRow>

        <FormRow>
          <YesNoRadioGroupWithField name={alreadyCustomer} />
        </FormRow>
        <FormRow>
          <YesNoRadioGroupWithField
            name={alreadyContactWithBank}
            caption={t(userProfileAlreadyContactWithBank.caption, { bankName: partnerName })}
          />
        </FormRow>
        <Condition validation={showContactPersonName}>
          <InputWithField
            name={nameOfContactPerson}
            placeholder={t(userProfileContactPerson.placeholder)}
          />
        </Condition>
      </FormSection>
    </Condition>
  );
};
